import { useState, useRef, useEffect } from "react";
import { format } from "date-fns";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { FaRegCalendarAlt } from "react-icons/fa";
import moment from "moment";

const SingleDatePicker = ({ submitHandler, defaultLabel = "Select Date", initialDate, maxDate = new Date(), minDate = moment().subtract(2, "year").toDate() }) => {
    const dropdownRef = useRef(null);
    const [showDropdown, setShowDropdown] = useState(false);
    const [selectedDate, setSelectedDate] = useState(() => {
        // Properly initialize with either initialDate or today's date
        return initialDate ? new Date(initialDate) : new Date();
    });
    const [label, setLabel] = useState(() => {
        return initialDate ? format(new Date(initialDate), "dd MMM yyyy") : defaultLabel;
    });

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowDropdown(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const handleDateChange = (date) => {
        setSelectedDate(date);
        setLabel(format(date, "dd MMM yyyy"));
        setShowDropdown(false);
        submitHandler(date); // Pass the Date object directly
    };

    return (
        <div className="flex text-left h-10 text-gray-600" ref={dropdownRef}>
            <button
                onClick={() => setShowDropdown(!showDropdown)}
                className="inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md bg-white hover:bg-gray-50"
            >
                <FaRegCalendarAlt className="h-4 w-4 mr-2 text-gray-700" />
                {label}
            </button>

            {showDropdown && (
                <div className="absolute z-10 mt-10 bg-white border border-gray-200 rounded-md shadow-lg p-4">
                    <Calendar
                        onChange={handleDateChange}
                        value={selectedDate}
                        //maxDate={new Date()}
                        maxDate={maxDate}
                        minDate={minDate}
                        className="border-0"
                    />
                </div>
            )}
        </div>
    );
};

export default SingleDatePicker;